export enum MainButtonVisualEnum {
    primary = 'primary',
    secondary = 'secondary',
    alwaysWhite = 'alwaysWhite',
}